package com.example.hukakmp.identification

data class IdentifiedFish(
    val commonName: String,
    val scientificName: String? = null,
    val confidence: Int? = null,
)

data class FishIdentification(
    val isFishingImage: Boolean,
    val species: List<IdentifiedFish>,
    val summary: String,
)

sealed interface FishIdentificationResult {
    data class Success(val identification: FishIdentification) : FishIdentificationResult
    data class Error(val message: String) : FishIdentificationResult
}

expect val fishIdentificationAvailable: Boolean

expect suspend fun identifyFishPhoto(
    bytes: ByteArray,
    contentType: String,
): FishIdentificationResult
